import React, { useState } from "react";
import Footer from "../components/Footer";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import PhoneInput from "react-phone-input-2";

import 'react-phone-input-2/lib/style.css'

import { Helmet } from "react-helmet";
import Swal from "sweetalert2";
import { HashLink } from "react-router-hash-link";
const Preloader = () => (
  <div class="loader"></div>
);
const Home = () => {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePhoneChange = (value) => {
    setFormData({ ...formData, phone: value });
  };
  const apiKey = process.env.REACT_APP_API_KEY;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch("https://api.v1.spotyourleads.com/inquiry/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": apiKey,

        },

        body: JSON.stringify(formData),
      });

      const result = await response.json();
      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Your inquiry has been submitted.",
        });

        setFormData({ name: "", email: "", phone: "", message: "" });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: result.message || "Something went wrong. Try again!",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: "Please check your connection and try again.",
      });
    }

    setIsSubmitting(false);
  };

  // const handleSubmit = async (event) => {
  //     event.preventDefault();
  //     setIsSubmitting(true);

  //     const currentDate = new Date();
  //     const formattedDate = currentDate.toLocaleString("en-US");
  //     const year = new Date(formattedDate).getFullYear();
  //     const month = (new Date(formattedDate).getMonth() + 1)
  //         .toString()
  //         .padStart(2, "0");
  //     const day = new Date(formattedDate).getDate().toString().padStart(2, "0");

  //     const dateWithoutAmPm = formattedDate.slice(0, -3);
  //     const amPm = formattedDate.slice(-3);
  //     const milliseconds = currentDate
  //         .getMilliseconds()
  //         .toString()
  //         .padStart(3, "0");

  //     const formattedDateWithMilliseconds = `${dateWithoutAmPm}.${milliseconds}${amPm}`;

  //     const uid = formattedDateWithMilliseconds
  //         .replaceAll("/", "_")
  //         .replaceAll(":", "-")
  //         .replace(", ", "@")
  //         .replace(" ", "#");

  //     const docName = `${day}_${month}_${year}`;



  //     const submitData = {
  //         [uid]: formData,
  //     };

  //     await setDoc(doc(db, "messages", docName), submitData, {
  //         merge: true,
  //     });
  //     const emailHtml = `Hey ${formData.name},<br/>We have received your Message submitted via our website. Our team is on it and will get back to you as soon as possible. If you have any questions in the meantime, feel free to reach out by replying to this email.<br/><br/>Thank you,<br/><br/>`;
  //     const signatureHtml = `  <font color="#888888">
  //         <span class="gmail_signature_prefix">-- </span><br>
  //         <div dir="ltr" class="gmail_signature" data-smartmail="gmail_signature">
  //             <div dir="ltr">
  //                 <table class="signature-table" width="414" cellpadding="0" cellspacing="0" border="0">
  //                     <tbody>
  //                         <tr>
  //                             <td valign="top" class="signature-cell">
  //                                 <table border="0" cellpadding="0" cellspacing="0" width="414" class="inner-table">
  //                                     <tbody>
  //                                         <tr>
  //                                         <!--
  //                                             <td class="no-padding">
  //                                                 <span class="name-title"><font face="arial black, sans-serif">Samir H</font></span>
  //                                             </td>
  //                                             -->
  //                                             <td class="no-padding"></td>
  //                                         </tr>
  //                                         <tr>
  //                                             <td class="no-padding">
  //                                                 <span class="position-title"><font face="arial black, sans-serif">Client Success Manager<br><br></font></span>
  //                                             </td>
  //                                             <td align="right" width="170" class="no-padding">
  //                                                 <p dir="ltr" class="social-links">
  //                                                     <span>
  //                                                         <a href="http://spotYourLeads.com/" target="_blank">
  //                                                             <img src="https://lh7-us.googleusercontent.com/ERQye9fHlkGU5k3qeAOaIPlXt6WEXXaU3Qk6sX-RPc989aGEznY7hiAxlQrZZy4jbAFXGrMQpBM7XooSYiCJQoTXjmwx2feUNpI2IMZAFp4rcsQCUmyJTDeeYB7wXVKx2ajwEOROluc4SDSAovfxy44" width="23" height="23" alt="Website" class="icon">
  //                                                         </a>&nbsp;
  //                                                     </span>
  //                                                     <span>
  //                                                         <a href="https://www.instagram.com/spotYourLeads/" target="_blank">
  //                                                             <img src="https://lh7-us.googleusercontent.com/RBHXzA6EarsjkC28LnCKIOX46gSouRWQvToQulLKq_T8amnmvJz3GO1Pd5GML1bps41dLRSlJe8y3UR6olRNRWBBzflLsAPtb2KI9n6PynABhc6WXrH3CrSimE6b-7cn4ntkAr6EnTkr2i0Qw9QQr0w" width="23" height="23" alt="Instagram" class="icon">
  //                                                         </a>&nbsp;
  //                                                     </span>
  //                                                    <!--

  //                                                     <span>
  //                                                         <a href="https://wa.me/15619225376" target="_blank">
  //                                                             <img src="https://lh7-us.googleusercontent.com/Rgf8cTDfganYaSmVeRG8an1XXfBmeubjqi1eCPjKsprqPPgN6A-isjGF-TvzNNacha4ut_sMzFYXo3DbOEMb9SIcp4vA1kKnvykcTww8iV_wh2L6GsyVb9aTQiZO5e7m-2hESYGqdtbnOFF8WJBWuUg" width="23" height="23" alt="WhatsApp" class="icon">
  //                                                         </a>&nbsp;
  //                                                     </span>
  //                                                     <span>
  //                                                         <a href="https://www.linkedin.com/company/100955777" target="_blank">
  //                                                             <img src="https://lh7-us.googleusercontent.com/0554XXBDxwmR3G1JA7ijlqWufEnXfK_l1LUpuqg-eydQVjai3t0GXbVp1xrqfvKH1g1thL1EzqjUpMqvwITbTb7ndmCv1125NqDuBN45wsCQkCB17bxXIpAEfbCMv_G2WQwpAqFp6vIBmNo3uqgzKMI" width="23" height="23" alt="LinkedIn" class="icon">
  //                                                         </a>
  //                                                     </span>
  //                                                     -->
  //                                                 </p>
  //                                             </td>
  //                                         </tr>
  //                                         <tr>

  //                                             <td class="no-padding">
  //                                                 <span class="contact-info">
  //                                                    <!--

  //                                                     <span class="icon-cell">
  //                                                         <img src="https://lh7-us.googleusercontent.com/qv5uavYFMPAfRw6bWUk8GYOV-ngLGdu4ndYfyql8dq8Cogw2Jfgm4IZhbUIyj50D0kNLCA-J8mF_YCkw5RrKm-6p3cQog0MTiVkR6WE_EK5fcMgLP9ufvtzS_N87-tNRUJuucuG9sNvShAplf9oDnW4" width="19" height="19" class="contact-icon">
  //                                                     </span>
  //                                                     <font face="arial black, sans-serif">(310) 601-8347</font>
  //                                                     <br>
  //                                                     <span class="icon-cell">
  //                                                         <img src="https://lh7-us.googleusercontent.com/d6sEan4jectEq-6hIecRokXTA4nHSmFDVk0v71K5EXwxoepvfnMyxoNfUhrrTlVOLbssr81WHwRaBO-IhvFHOrD2vkl0gsB7nmxPznFc_YGxFTRiwwvhQMgxlr4i3mPJ2gz9SSNdsbZFLQMRs0JZzQo" width="19" height="19" class="contact-icon">
  //                                                     </span>&nbsp;
  //                                                     -->
  //                                                     <a href="mailto:support@spotYourLeads.com" class="email-link">support@spotYourLeads.com</a>&nbsp; &nbsp; &nbsp;
  //                                                 </span>
  //                                             </td>
  //                                             <td valign="bottom" align="right" class="no-padding"></td>
  //                                         </tr>
  //                                     </tbody>
  //                                 </table>
  //                             </td>
  //                         </tr>
  //                                                                                <!--

  //                         <tr>
  //                             <td class="banner-cell">

  //                                 <a href="https://spotYourLeads.com/" target="_blank">
  //                                     <img border="0" alt="Banner" width="414" src="https://ci3.googleusercontent.com/meips/ADKq_Nao5PJGW-cu5EO2By_8Ke9Dcl1rL90Pfc7dZ7nzBIH9qx9rk_HYSLsB2oqY6rLLWq_UIJ-n=s0-d-e1-ft#https://i.imgur.com/u495xLU.png" class="banner-image">
  //                                 </a>
  //                             </td>
  //                         </tr>
  //                         -->
  //                         <tr>
  //                             <td class="disclaimer-cell">
  //                                 The content of this email is confidential and intended for the recipient specified in message only. It is strictly forbidden to share any part of this message with any third party, without a written consent of the sender. If you received this message by mistake, please reply to this message and follow with its deletion, so that we can ensure such a mistake does not occur in the future.
  //                             </td>
  //                         </tr>
  //                     </tbody>
  //                 </table>
  //             </div>
  //         </div>
  //     </font>`;
  //     const fullHtml = emailHtml + signatureHtml;

  //     addDoc(collection(db, "mail"), {
  //         to: formData.email,
  //         message: {
  //             subject: "spotYourLeads | We Have Received Your Message!",
  //             html: fullHtml,
  //         },
  //     });
  //     await addDoc(collection(db, "mail"), {
  //         to: "support@spotYourLeads.com",
  //         message: {
  //             subject: "New Message Submitted",
  //             html: `<code><h1>New Message</h1><h2>Name: ${formData.name}</h2><h2>Email: ${formData.email}</h2><h2>Phone: ${formData.phone}</h2><h2>Message: ${formData.message}</h2></code>`,
  //         },
  //     });
  //     event.target.reset()
  //     Swal.fire({
  //         icon: 'success',
  //         title: 'Sent successfully',
  //         text: "Message Sent successfully ",
  //         timer: 1000,
  //         customClass: {
  //             confirmButton: 'my-confirm-button',
  //         }

  //     }).then(handleNewInquiry)


  // };



  // const handleNewInquiry = () => {
  //     setFormData({});
  //     setIsSubmitting(false);

  // };
  return (
    <>
      <Helmet>
        <title>Spot Your Leads | Buy Verified Real Estate Leads Hassle-Free
        </title>
      </Helmet>
      <section className="homeFirst">
        <Container>
          <Row>
            <Col lg={7} md={7} sm={12}>
              <div className="firstDiv">
                <h1>Explore Opportunities Near You</h1>
                <p>With our interactive map, finding the right lead
                  has never been easier. Search by location, filter

                  by property type, and claim your next big
                  opportunity today.
                  <br />

                </p>
                <Link to="/leads-shop" >
                  <button> Start Exploring Now</button>
                </Link>
                <HashLink className="inquiry-home-btn" to="/#Contact" >
                  <button>Submit an Inquiry</button>
                </HashLink>
              </div>

            </Col>
            <Col lg={5} md={5} sm={12}>
              <img src="images/Layer_54.svg" alt="" />
            </Col>
          </Row>
        </Container>
      </section>
      <section className="homeSecond">
        <Container>
          <Row>
            <Col lg={5} md={5} sm={12} className="imgmob">

              <img src="images/about.svg" alt="about" />

            </Col>
            <Col lg={6} md={6} sm={12}>
              <div className="rightSecond">
                <h3>Look For It, Claim It, Close It—
                  <br />
                  Your Lead Journey Starts Here.</h3>
                <p>
                  <span>Spot Your Lead </span> connects you to verified real estate
                  opportunities. Start your journey today and make
                  every lead count.
                </p>


              </div>
            </Col>


          </Row>
        </Container>
      </section>

      <section className="homeThird">
        <h2>Contact Us</h2>
        <Container>
          <Row>
            <Col lg={6} md={6} sm={12}>
              <div className="rightThird">
                <h3>We’re Here to Help You Succeed.</h3>
                <p>
                  Have questions or need support?
                  <br />
                  Our dedicated team is here to ensure your experience
                  with Spot Your Lead is seamless. Reach out to us
                  anytime!
                </p>

              </div>
            </Col>
            <Col lg={6} md={6} sm={12} className="imgmob">

              <img src="images/contact.svg" alt="about" />

            </Col>

          </Row>
        </Container>
      </section>
      <section className="homeFourth formSection" id="Contact">
        <h2>Quick contact form for inquiries</h2>
        <Container>
          <Row>
            <Col lg={6} md={6} sm={12}>

              <img src="images/Group.svg" alt="contact" />

            </Col>
            <Col lg={6} md={6} sm={12}>
              <div className="formDiv">
                <form onSubmit={handleSubmit}>
                  <div>
                    <input
                      className="form-control"
                      name="name"
                      placeholder="Name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div>
                    <input
                      className="form-control"
                      name="email"
                      placeholder="Email Address"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div>
                    <PhoneInput
                      country={"us"}
                      inputProps={{ name: "phone", required: true }}
                      inputClass="form-control"
                      value={formData.phone}
                      onChange={handlePhoneChange}
                      placeholder="Phone Number"
                    />
                  </div>
                  <div>
                    <textarea
                      name="message"
                      className="form-control"
                      placeholder="Message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>
                  <div className='checkbox'>
                    <input name="recive" type='checkbox' />
                    <p>I Consent to Receive SMS Notifications, Alerts from Spot Your Leads. Message frequency varies. Message & data rates may apply. Text HELP to (786) 485-0848 for assistance. You can reply STOP to unsubscribe at any time.


                    </p>
                  </div>
                  <div>
                    <button type="submit" disabled={isSubmitting}>
                      {isSubmitting ? <Preloader /> : "Submit"}
                    </button>

                  </div>
               
            
                  <div className="terms-privacy">
                    <Link to="/terms-and-conditions">
                      <span>Terms & conditions</span>
                    </Link>
                    <p> |  </p>
                    <Link to="/privacy-policy">
                      <span>Privacy Policy</span>
                    </Link>

                  </div>
                </form>

              </div>
            </Col>


          </Row>
        </Container>
      </section>
      <Footer />
    </>
  );
};

export default Home;
